import { render, staticRenderFns } from "./form.html?vue&type=template&id=031e8c1e&scoped=true&external"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031e8c1e",
  null
  
)

export default component.exports